// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__38V7S","root":"style_root__3j12L","items":"style_items__Skvui","slider":"style_slider__2lY1-","slideLeft":"style_slideLeft__3I4oE"};